import { Form as FormContainer } from 'components/Form'
import { SignInVars } from 'features/user/api/types/signIn'
import { useSignIn } from 'features/user/hooks/useSignIn'
import { Form } from './Form'
import { schema, schemaDefaults } from './schema'

export const UserLoginForm = (): React.JSX.Element => {
  const { errors: apiErrors, loading, signIn } = useSignIn()

  return (
    <FormContainer<SignInVars>
      externalErrors={apiErrors}
      loading={loading}
      onSubmit={signIn}
      schema={schema}
      schemaDefaults={schemaDefaults}
      withLeaveDialog={false}
    >
      {() => <Form />}
    </FormContainer>
  )
}
